import { DateRange } from './date';

export class MerchantProduct {
    id: number;
    code: string;
    action: string;
    module: string;
    startDate: string;
    endDate: string;
    appCode: string;
    createdBy: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
}
export class MerchantProductSearch {
    createdDate: DateRange = DateRange.empty();
    id = '';
    productId = 0;
    name = '';
    category='';
    merchantName = '';
    startDate = '';
    endDate = '';
    appCode = '';
    merchantId = '';
    locationId = '';

}